import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import './dnd.css';
import { Disposable } from '../../../base/common/lifecycle.js';
import { isMacintosh } from '../../../base/common/platform.js';
import { registerEditorContribution } from '../../browser/editorExtensions.js';
import { Position } from '../../common/core/position.js';
import { Range } from '../../common/core/range.js';
import { Selection } from '../../common/core/selection.js';
import { DragAndDropCommand } from './dragAndDropCommand.js';
import { ModelDecorationOptions } from '../../common/model/textModel.js';

function hasTriggerModifier(e) {
  if (isMacintosh) {
    return e.altKey;
  } else {
    return e.ctrlKey;
  }
}

export var DragAndDropController = /*#__PURE__*/function (_Disposable) {
  _inherits(DragAndDropController, _Disposable);

  var _super = _createSuper(DragAndDropController);

  function DragAndDropController(editor) {
    var _this;

    _classCallCheck(this, DragAndDropController);

    _this = _super.call(this);
    _this._editor = editor;

    _this._register(_this._editor.onMouseDown(function (e) {
      return _this._onEditorMouseDown(e);
    }));

    _this._register(_this._editor.onMouseUp(function (e) {
      return _this._onEditorMouseUp(e);
    }));

    _this._register(_this._editor.onMouseDrag(function (e) {
      return _this._onEditorMouseDrag(e);
    }));

    _this._register(_this._editor.onMouseDrop(function (e) {
      return _this._onEditorMouseDrop(e);
    }));

    _this._register(_this._editor.onKeyDown(function (e) {
      return _this.onEditorKeyDown(e);
    }));

    _this._register(_this._editor.onKeyUp(function (e) {
      return _this.onEditorKeyUp(e);
    }));

    _this._register(_this._editor.onDidBlurEditorWidget(function () {
      return _this.onEditorBlur();
    }));

    _this._register(_this._editor.onDidBlurEditorText(function () {
      return _this.onEditorBlur();
    }));

    _this._dndDecorationIds = [];
    _this._mouseDown = false;
    _this._modifierPressed = false;
    _this._dragSelection = null;
    return _this;
  }

  _createClass(DragAndDropController, [{
    key: "onEditorBlur",
    value: function onEditorBlur() {
      this._removeDecoration();

      this._dragSelection = null;
      this._mouseDown = false;
      this._modifierPressed = false;
    }
  }, {
    key: "onEditorKeyDown",
    value: function onEditorKeyDown(e) {
      if (!this._editor.getOption(25
      /* dragAndDrop */
      ) || this._editor.getOption(13
      /* columnSelection */
      )) {
        return;
      }

      if (hasTriggerModifier(e)) {
        this._modifierPressed = true;
      }

      if (this._mouseDown && hasTriggerModifier(e)) {
        this._editor.updateOptions({
          mouseStyle: 'copy'
        });
      }
    }
  }, {
    key: "onEditorKeyUp",
    value: function onEditorKeyUp(e) {
      if (!this._editor.getOption(25
      /* dragAndDrop */
      ) || this._editor.getOption(13
      /* columnSelection */
      )) {
        return;
      }

      if (hasTriggerModifier(e)) {
        this._modifierPressed = false;
      }

      if (this._mouseDown && e.keyCode === DragAndDropController.TRIGGER_KEY_VALUE) {
        this._editor.updateOptions({
          mouseStyle: 'default'
        });
      }
    }
  }, {
    key: "_onEditorMouseDown",
    value: function _onEditorMouseDown(mouseEvent) {
      this._mouseDown = true;
    }
  }, {
    key: "_onEditorMouseUp",
    value: function _onEditorMouseUp(mouseEvent) {
      this._mouseDown = false; // Whenever users release the mouse, the drag and drop operation should finish and the cursor should revert to text.

      this._editor.updateOptions({
        mouseStyle: 'text'
      });
    }
  }, {
    key: "_onEditorMouseDrag",
    value: function _onEditorMouseDrag(mouseEvent) {
      var target = mouseEvent.target;

      if (this._dragSelection === null) {
        var selections = this._editor.getSelections() || [];
        var possibleSelections = selections.filter(function (selection) {
          return target.position && selection.containsPosition(target.position);
        });

        if (possibleSelections.length === 1) {
          this._dragSelection = possibleSelections[0];
        } else {
          return;
        }
      }

      if (hasTriggerModifier(mouseEvent.event)) {
        this._editor.updateOptions({
          mouseStyle: 'copy'
        });
      } else {
        this._editor.updateOptions({
          mouseStyle: 'default'
        });
      }

      if (target.position) {
        if (this._dragSelection.containsPosition(target.position)) {
          this._removeDecoration();
        } else {
          this.showAt(target.position);
        }
      }
    }
  }, {
    key: "_onEditorMouseDrop",
    value: function _onEditorMouseDrop(mouseEvent) {
      if (mouseEvent.target && (this._hitContent(mouseEvent.target) || this._hitMargin(mouseEvent.target)) && mouseEvent.target.position) {
        var newCursorPosition = new Position(mouseEvent.target.position.lineNumber, mouseEvent.target.position.column);

        if (this._dragSelection === null) {
          var newSelections = null;

          if (mouseEvent.event.shiftKey) {
            var primarySelection = this._editor.getSelection();

            if (primarySelection) {
              var selectionStartLineNumber = primarySelection.selectionStartLineNumber,
                  selectionStartColumn = primarySelection.selectionStartColumn;
              newSelections = [new Selection(selectionStartLineNumber, selectionStartColumn, newCursorPosition.lineNumber, newCursorPosition.column)];
            }
          } else {
            newSelections = (this._editor.getSelections() || []).map(function (selection) {
              if (selection.containsPosition(newCursorPosition)) {
                return new Selection(newCursorPosition.lineNumber, newCursorPosition.column, newCursorPosition.lineNumber, newCursorPosition.column);
              } else {
                return selection;
              }
            });
          } // Use `mouse` as the source instead of `api`.


          this._editor.setSelections(newSelections || [], 'mouse');
        } else if (!this._dragSelection.containsPosition(newCursorPosition) || (hasTriggerModifier(mouseEvent.event) || this._modifierPressed) && (this._dragSelection.getEndPosition().equals(newCursorPosition) || this._dragSelection.getStartPosition().equals(newCursorPosition)) // we allow users to paste content beside the selection
        ) {
          this._editor.pushUndoStop();

          this._editor.executeCommand(DragAndDropController.ID, new DragAndDropCommand(this._dragSelection, newCursorPosition, hasTriggerModifier(mouseEvent.event) || this._modifierPressed));

          this._editor.pushUndoStop();
        }
      }

      this._editor.updateOptions({
        mouseStyle: 'text'
      });

      this._removeDecoration();

      this._dragSelection = null;
      this._mouseDown = false;
    }
  }, {
    key: "showAt",
    value: function showAt(position) {
      var newDecorations = [{
        range: new Range(position.lineNumber, position.column, position.lineNumber, position.column),
        options: DragAndDropController._DECORATION_OPTIONS
      }];
      this._dndDecorationIds = this._editor.deltaDecorations(this._dndDecorationIds, newDecorations);

      this._editor.revealPosition(position, 1
      /* Immediate */
      );
    }
  }, {
    key: "_removeDecoration",
    value: function _removeDecoration() {
      this._dndDecorationIds = this._editor.deltaDecorations(this._dndDecorationIds, []);
    }
  }, {
    key: "_hitContent",
    value: function _hitContent(target) {
      return target.type === 6
      /* CONTENT_TEXT */
      || target.type === 7
      /* CONTENT_EMPTY */
      ;
    }
  }, {
    key: "_hitMargin",
    value: function _hitMargin(target) {
      return target.type === 2
      /* GUTTER_GLYPH_MARGIN */
      || target.type === 3
      /* GUTTER_LINE_NUMBERS */
      || target.type === 4
      /* GUTTER_LINE_DECORATIONS */
      ;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._removeDecoration();

      this._dragSelection = null;
      this._mouseDown = false;
      this._modifierPressed = false;

      _get(_getPrototypeOf(DragAndDropController.prototype), "dispose", this).call(this);
    }
  }]);

  return DragAndDropController;
}(Disposable);
DragAndDropController.ID = 'editor.contrib.dragAndDrop';
DragAndDropController.TRIGGER_KEY_VALUE = isMacintosh ? 6
/* Alt */
: 5
/* Ctrl */
;
DragAndDropController._DECORATION_OPTIONS = ModelDecorationOptions.register({
  className: 'dnd-target'
});
registerEditorContribution(DragAndDropController.ID, DragAndDropController);